<template>
  <client-only>
    <div id="xg-player-wrap" class="ml:w-100vw ml:h-100vh ml:max-w-100vw"></div>
  </client-only>
</template>

<script setup>
import { ref, onMounted, reactive, computed, nextTick } from 'vue';
import Player, { Events } from 'xgplayer'; // 引入西瓜视频模块
import 'xgplayer/dist/index.min.css'; // 引入西瓜视频样式

import { conf } from "./conf"; // 配置文件单独拎出来一个js文件
defineOptions({ name: 'MyVideo' })

let player = null // 实例
let isMutedDueToAutoplay = true // 标记是否因为自动播放而静音

onMounted(() => {
  nextTick(() => {
    // const mobilePlayerWrap = document.getElementById('xg-player-wrap');
    // console.log('xg-player-wrap', mobilePlayerWrap)
    // mobilePlayerWrap.addEventListener('click', () => {
    //   console.log('xg-player-wrap clicked', player)
    // })
    init()
  })
})

const init = () => {
  // 更新配置中的id
  const playerConf = {
    ...conf,
    id: "xg-player-wrap"
  };

  player = new Player(playerConf);

  // 确保视频元素具有正确的属性
  // 这一段时确保ios视频播放不全屏
  const videoEl = player.media;
  if (videoEl) {
    videoEl.setAttribute('playsinline', 'true');
    videoEl.setAttribute('webkit-playsinline', 'true');
    videoEl.setAttribute('x5-playsinline', 'true');
    videoEl.setAttribute('x5-video-player-type', 'h5');
    videoEl.setAttribute('x5-video-player-fullscreen', 'false');
    videoEl.setAttribute('x-webkit-airplay', 'allow');
  }

  player.on(Events.PLAY, (ev) => {
    console.log('-播放开始-', ev);
    // 当用户点击播放时，如果当前是静音状态且是因为自动播放而静音，则取消静音
    if (isMutedDueToAutoplay && player.volume === 0) {
      player.volume = 0.72; // 设置为配置中的音量
      player.muted = false; // 取消静音
      isMutedDueToAutoplay = false; // 标记已取消静音
    }
  })

  player.on(Events.PAUSE, (ev) => {
    console.log('-播放结束-', ev);
  })

  player.on('loadedmetadata', (ev) => {
    console.log('-媒体数据加载好了-', ev);
  })

  player.on(Events.SEEKED, (ev) => {
    console.log('-跳着播放-', ev);
  })

  // 监听用户交互，当用户点击播放按钮时取消静音
  player.on(Events.USER_ACTION, (ev) => {
    if (isMutedDueToAutoplay && player.muted) {
      player.volume = 0.72;
      player.muted = false;
      isMutedDueToAutoplay = false;
    }
  });

  // 等各种监听事件
}
</script>

<style lang="scss" scoped>
#xg-player-wrap {
  overflow: hidden;
  border-radius: 0.5rem;

  /* 8px */
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
